import { render } from "./AdminCompanyDetailsView.vue?vue&type=template&id=b7c1b2e0&ts=true&lang=pug"
import script from "./AdminCompanyDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminCompanyDetailsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__